<div class="new-task-view">
<form [formGroup]="parkingForm" fxLayout class="parkingForm">
    <div>
      <mat-label>Type of Task*</mat-label> <br>
      <mat-form-field appearance="outline">
        <mat-select placeholder="Select" formControlName="typeOfTask" (selectionChange)="onSelectValue($event)" required>
          <mat-option *ngFor="let type of formTypes" [value]="type.id">{{type.name}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

     <!--Create Other Task form Starts-->
    <div *ngIf="displaySection=='2'">
      <div>
        <mat-label>Aircraft</mat-label> <br>
        <mat-form-field appearance="outline">
          <input maxlength="10" formControlName="aircraft" matInput />
        </mat-form-field>
      </div>

      <mat-label>Pick Up Location</mat-label> <br>
      <div class="pickup-dropoff-loc-section">
        <mat-form-field appearance="outline">
          <mat-select placeholder="Location" #pickUpLocation formControlName="pickUpLocation">
            <mat-option *ngFor="let type of locations" [value]="type.name">{{type.name}}</mat-option>
          </mat-select>
        </mat-form-field>
        <div *ngIf="pickUpLocation.value === 'Ramp'">
          <mat-form-field appearance="outline">
            <mat-select placeholder="Ramp" formControlName="pickUpRamp" (selectionChange)="onSelectPickupRamp($event)">
              <mat-option *ngFor="let ramp of ramps" [value]="ramp.locationName">{{ramp.locationName}}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-select placeholder="Spot" formControlName="pickUpSpot">
              <mat-option *ngFor="let spot of rampPickUpSpots" [value]="spot.locationName">{{spot.locationName}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <mat-label>Drop Off Location<span class="required"> *</span></mat-label> <br>
      <div class="pickup-dropoff-loc-section">
        <mat-form-field appearance="outline">
          <mat-select placeholder="Location" #dropoffLocation formControlName="dropoffLocation" required>
            <mat-option *ngFor="let type of locations" [value]="type.name">{{type.name}}</mat-option>
          </mat-select>
        </mat-form-field>
        <div *ngIf="dropoffLocation.value === 'Ramp'">
          <mat-form-field appearance="outline">
            <mat-select placeholder="Ramp" formControlName="dropOffRamp" (selectionChange)="onSelectDropOffRamp($event)">
              <mat-option *ngFor="let ramp of ramps" [value]="ramp.locationName">{{ramp.locationName}}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-select placeholder="Spot" formControlName="dropOffSpot">
              <mat-option *ngFor="let spot of rampDropOffSpots" [value]="spot.locationName">{{spot.locationName}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div *ngIf="displaySection=='1' || displaySection=='2'" class="timepicker-container">
      <div class="time-container">
        <mat-label>Start Time</mat-label> <br>
        <app-time-picker (result)="getPickerStartDateTime($event)" [dateTimeString]="defaultStartTime" [minDate]="minFilterDate"></app-time-picker>
      </div>
      <div class="time-container">
        <mat-label>End Time</mat-label> <br>
        <app-time-picker (result)="getPickerEndDateTime($event)" [dateTimeString]="defaultEndTime" [minDate]="minFilterDate"></app-time-picker>
      </div>
    </div>
    <div *ngIf="displaySection=='2'" class="add-pickup-section">
      <mat-label>Pickup Details</mat-label> <br>
      <div formArrayName="addOnDetails">
        <div *ngFor="let detail of addOnDetails.controls;let i=index">
          <div [formGroupName]="i" [ngStyle]="{'display':'flex'}">
            <mat-select matPrefix placeholder="Select" formControlName="passengerType">
              <mat-option *ngFor="let name of addOnTypes" [value]="name">{{name}}</mat-option>
            </mat-select>
            <mat-form-field appearance="outline">
              <input matInput formControlName="passengerName" maxlength="25"/>
              <button mat-button (click)="removeAddOnDetails(i)" class="remove-details" matSuffix><mat-icon>delete_outline</mat-icon></button>
            </mat-form-field>
          </div>
        </div>
      </div>
      <button mat-icon-button aria-label="Add Pickup Details" class="add-pickup-button" (click)="addAddOnDetails($event)">
        <mat-icon>add_circle</mat-icon>
      </button>
    </div>
    <div *ngIf="displaySection=='1' || displaySection=='2'">
      <mat-label>Notes</mat-label> <br>
      <mat-form-field appearance="outline" class="notes">
        <textarea class="notesText" matInput formControlName="notes" maxlength="250"></textarea>
      </mat-form-field>
    </div>
    <div *ngIf="displaySection=='1' || displaySection=='2'" class="formfooter">
      <div [hidden]="!isCoordinator">
        <mat-label>Assign to:</mat-label>
        <mat-form-field appearance="outline">
          <mat-select placeholder="Select" [value]="'Unassigned'" formControlName="assignedTo">
            <mat-option [value]="'Unassigned'">Unassigned</mat-option>
            <div>
              <mat-option *ngFor="let driver of driversForList" [value]="driver.driverId">
              {{driver.driverFirstName[0] || ''}}. {{driver.driverLastName || ''}}
              </mat-option>
            </div>
          </mat-select>
        </mat-form-field>
      </div>
      <div>
        <button mat-button color="primary" (click)="cancel()">Cancel</button>
        <button type="button" mat-raised-button color="primary" class="buildtask" (click)="buildTask()">
         <span>Build Task and Assign</span>&nbsp;<mat-icon>playlist_add</mat-icon>
        </button>
      </div>
    </div>
     <!--Create Remote Parking Form and Other Task form Ends-->
  </form>
</div>
